module.exports = __webpack_public_path__ + "img/ico-liver-cancer-90-x-90.1671e1f4.svg";